const INCORRECT_CODE = "Invalid Voucher code!";
const ALREADY_CLAIMED = "Voucher has already been claimed!";

const CLAIM_VOUCHER_ERRORS: Record<string, string> = {
  [INCORRECT_CODE]: "Please check if you entered the correct code",
  [ALREADY_CLAIMED]: "You have claimed this voucher",
};

export { CLAIM_VOUCHER_ERRORS };
